import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { getAllCategory } from "service/Common";
import { Toast } from "utils/toast";

import styles from "./SelectCategory.module.scss";

const SelectCategory = () => {
  const [category, setCategory] = useState(null);

  useEffect(() => {
    getCategory();
  }, []);

  const getCategory = async () => {
    try {
      let response = await getAllCategory();
      if (response.status == 200) {
        setCategory(response.data.data);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  if (category == null) return null;

  return (
    <div className={styles.category_box}>
      <div className={styles.category_title}>
        <span>Choose the category of the product you wish to donate</span>
      </div>
      {category.map((list, index) => {
        return (
          <div
            key={index}
            className={styles.main_category}
            style={{
              borderColor: index + 1 !== category.length ? "#C4C4C4" : "white",
            }}
          >
            <Link to={`/admin/donation/add/${list._id}`}>
              <b>{list.categoryName}</b>
            </Link>
            <UncontrolledDropdown direction="right">
              <DropdownToggle tag="span" data-toggle="dropdown">
                <i
                  className="icon-next-arrow"
                  style={{ display: "inline-block", marginTop: "8px" }}
                ></i>
              </DropdownToggle>
              <DropdownMenu>
                {list.subCategories.map((item, ind) => {
                  return (
                    <Link key={ind} to={`/admin/donation/add/${item._id}`}>
                      <DropdownItem>
                        <div className="dropdown-items">
                          <span>{item.categoryName}</span>
                        </div>
                      </DropdownItem>
                    </Link>
                  );
                })}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        );
      })}
    </div>
  );
};

export default SelectCategory;
